import { keyIssueUpdateFilterCriteria } from "../../../actions/key-issue-actions"

import KeyIssueFilterForm from "./KeyIssueFilterForm"

import buildItemConnector from "../../common/build-item-connector"

export default buildItemConnector(
    "keyIssues",
    true,
    keyIssueUpdateFilterCriteria
)(KeyIssueFilterForm)
